/**
 * SVG `<filter id="board-engraved-groove">` — inset die-cut grooves on an empty puzzle board.
 * Light from top-left: inner shadow shifts up-left (receding depth), highlight shifts down-right
 * (light on the bottom lip of the groove).
 *
 * @param {{ filterId?: string, shadowOpacity?: number, highlightOpacity?: number }} props
 */
export function BoardEngravedGrooveFilter({
    filterId = "board-engraved-groove",
    shadowOpacity = 0.42,
    highlightOpacity = 0.2,
}) {
    return (
        <filter
            id={filterId}
            x="-20%"
            y="-20%"
            width="140%"
            height="140%"
            colorInterpolationFilters="sRGB"
        >
            <feGaussianBlur in="SourceAlpha" stdDeviation="0.55" result="blur" />

            {/* Inner shadow — dark, up-left (groove wall away from the light source) */}
            <feOffset in="blur" dx="-1" dy="-1" result="shadowOffset" />
            <feFlood floodColor="#000000" floodOpacity={shadowOpacity} result="shadowColor" />
            <feComposite in="shadowColor" in2="shadowOffset" operator="in" result="innerShadow" />

            {/* Lip highlight — light, down-right (bottom edge catches top-left light) */}
            <feOffset in="blur" dx="1" dy="1" result="highlightOffset" />
            <feFlood floodColor="#ffffff" floodOpacity={highlightOpacity} result="highlightColor" />
            <feComposite in="highlightColor" in2="highlightOffset" operator="in" result="lipHighlight" />

            <feMerge>
                <feMergeNode in="innerShadow" />
                <feMergeNode in="lipHighlight" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
    );
}

/** Base groove stroke — dark, semi-transparent, blends into grey board. */
export const BOARD_ENGRAVED_GROOVE_STROKE = "rgba(20, 20, 20, 0.42)";

/** Stable filter name; suffix with useId() when duplicated on a page. */
export const BOARD_ENGRAVED_GROOVE_FILTER_BASE = "board-engraved-groove";
